import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitPopUpData } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { showDialog } from "@widgets/CommonDialog";
import SnSearchBtn from "@shared/components/SnSearchBtn";

interface popupProps {
  selectedData?: any;
  modalRef?: any;
}

const SN_TRA_IBL_REG_001_POP_001 = forwardRef(
  ({ selectedData, modalRef }: popupProps, ref: React.Ref<any>) => {
    const { userInfo } = global();

    const searchRef = useRef<any>(null);
    const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
      grid1: React.createRef(),
    });

    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);
    const [columns, setColums] = useState<any>({ grid1: [] });
    const [dataSources, setDataSources] = useState<any>({ grid1: [] });

    useImperativeHandle(ref, () => ({
      getSelectedRow: () => [
        gridRefs.current["grid1"].current?.getSelectedRows() || [],
      ],
    }));

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUpData(
            "SN_TRA_IBL_REG_001_POP_001",
            {}
          );
          setFormControlData(rtn.formControlData);
          setFormData({ ...rtn.formData, ...selectedData });
          setColums({ grid1: rtn.grid.grid1 });
        } catch (error) {}
      };
      fetchform();
    }, [userInfo]);

    const onSearch = async () => {
      try {
        const params = {
          id: "sn_tra_ibl_reg_001_POP_001_01",
          params: searchRef.current.getFormdata(),
        };
        const data: any = await fnGetDataSet(params);
        setDataSources({ grid1: data[0] || [] });

        if (data[0]?.length > 0) {
          await new Promise((resolve) => setTimeout(resolve, 50));
          gridRefs.current["grid1"].current?.selectAndFocusRow(0);
        }
      } catch (error: any) {
        showDialog("error", error.message);
      }
    };

    const onRowDoubleClicked = (event: any) => {
      if (!event?.data) return;
      modalRef?.current?.handleConfirm(true);
    };

    const grids = useMemo(
      () => ({
        grid1: {
          columns: columns.grid1,
          dataSource: dataSources.grid1,
          events: { onRowDoubleClicked },
        },
      }),
      [columns, dataSources]
    );

    return (
      <div style={{ position: "relative" }}>
        <div>
          <SearchPanel
            ref={searchRef}
            data={formData}
            controls={formControlData}
            popupRef={ref}
          ></SearchPanel>
        </div>
        <div style={{ textAlign: "center" }}>
          <SnSearchBtn
            text={"조회"}
            onClick={onSearch}
            sx={{ width: 80, marginTop: 1.5 }}
            spinner={true}
          />
        </div>
        <div style={{ height: "60vh", marginTop: "10px" }}>
          <SnGrid
            ref={gridRefs.current["grid1"]}
            columnConfig={grids.grid1.columns}
            rowData={grids.grid1.dataSource}
            etcProps={{ isEditable: false, rowSelection: "single" }}
            events={grids.grid1.events}
          />
        </div>
      </div>
    );
  }
);

export default SN_TRA_IBL_REG_001_POP_001;
